<template>
<div class="wrap">

<Tabs2 :data="['基础属性', '指定办理人', '表单操作权限', '按钮权限']"
@on-tab="handleTab"
:height="40"
:tab="tab" />

  <BaseInfo v-if="tab === 0" :item="item" @on-item="handleBaseInfo" />

  <div class="tab" v-if="tab === 1">
    <div class="padding">
      <el-radio v-model="personType" :label="assignType.t1">指定成员</el-radio>
      <el-radio v-model="personType" :label="assignType.t2">表单里的联系人</el-radio>
      <el-radio v-model="personType" :label="assignType.t3">发起人自己</el-radio>
      <el-radio v-model="personType" :label="assignType.t4">角色</el-radio>
    </div>
    <div class="padding">
      <el-button v-if="personType === assignType.t1" type="primary" round size="medium" icon="el-icon-plus" @click="handleOpen">添加成员</el-button>
      <el-select v-if="personType === assignType.t2" v-model="contactValue" placeholder="请选择表单里的人">
        <el-option
          v-for="item in fieldContacts"
          :key="item.prop"
          :label="item.label"
          :value="item.prop">
        </el-option>
      </el-select>

      <el-button v-if="personType === assignType.t4"
      type="primary"
      round size="medium"
      icon="el-icon-plus"
      @click="handleOpen2">添加角色</el-button>

      <div v-if="personType === assignType.t4" style="padding-top: 10px">
        <el-switch
          v-model="roleInfo.relateStartOrgId"
          active-color="#409eff">
        </el-switch>
        <span class="label">是否关联发起人所在部门</span>
      </div>
    </div>

    <div v-if="personType === assignType.t1" class="padding select">
      <el-tag
        closable
        size="mini"
        disable-transitions="true"
        v-for="tag in userDatas"
        :key="tag.index"
        @close="handleCloseUser(tag)"
        >
        {{tag.name}}
      </el-tag>
      <el-button style="margin-left: 10px;" type="text" v-if="userDatas.length" @click="handleClearTag">清空</el-button>
    </div>

    <div class="padding" v-if="roleInfo.name && personType === assignType.t4">
      <el-tag
        closable
        size="mini"
        disable-transitions="true"
        @close="handleClearTag2">{{ roleInfo.name }}</el-tag>
    </div>
  </div>

  <FormList v-if="tab === 2" :datas="fromPropertyList" @on-list="handleFormList" />

  <ButtonList v-if="tab === 3"
  :datas="buttonList"
  :item="item"
  @on-list="handleButtonList" />

  <UserSelect
  isHeadimg
  :visible.sync="dialogUser"
  :backDatas="userDatas"
  @onChecked="handleCheckedUser" />
  <RoleSelect
  :multiple="false"
  :visible.sync="dialogVisible"
  @onChecked="handleCheckedRole" />
</div>
</template>

<script>
import FormList from './FormList'
import ButtonList from './ButtonList'
import { mixinFormProperty, mixinButtonList, mixinTabs, mixinAssignMember } from '../mixins'
export default {
  mixins: [mixinFormProperty, mixinButtonList, mixinTabs, mixinAssignMember],
  components: {
    FormList,
    ButtonList
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
@import "./pop.scss";
</style>
